import React, {Component} from "react";
import {connect} from "react-redux";


import "./DatumSmall.css";

class DatumSmall extends Component {

  render() {
    const {label, value} = this.props;
    return (
      <div className="fow-datum-small">
        <div className="fow-datum-small-label fow-font-text fow-font-size-sm">{label}</div>
        <div className="fow-datum-small-value fow-font-text fow-font-size-md">{value}</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};
const mapDispatchToProps = dispatch => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(DatumSmall);
